// Constantes de dominio del módulo userprofile. Centralizan los magic strings
// que estaban dentro de los componentes: los nombres de campo del CRM (Zoho),
// el patrón de contraseña y los colores del diálogo de confirmación.

// Nombres de campo del metadata de Zoho CRM (apiName). El front los necesita
// para mapear las listas de valores (países, perfiles, etc.) que llegan crudas.
export const METADATA_FIELD = {
  COUNTRY: "Pais_Residencia",
  PROFESSIONAL_PROFILE: "Perfil_Profesional",
  NATIONALITY: "Nacionalidad",
  GENDER: "Genero",
};

// Patrón de contraseña: 8 a 16 caracteres, al menos un dígito, una minúscula y
// una mayúscula. Antes estaba duplicado en los dos campos del diálogo.
export const PASSWORD_PATTERN = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;

// Colores del diálogo de confirmación (sweetalert2) al actualizar el perfil.
export const SWAL_CONFIRM_COLOR = { CONFIRM: "#3085d6", CANCEL: "#d33" };
